import type { Transaction } from "../../../../schema.dev-sdk-api-appsync.generated";

export const transactionFields = (t: Transaction) =>
	[
		t.amount,
		t.approvalCode,
		t.bin,
		t.caid,
		t.cardMedia,
		t.cardholderUuid,
		t.catid,
		t.currency,
		t.emvAid,
		t.emvAppName,
		t.emvTagsPrint,
		t.externalReference,
		t.id,
		t.maskedPan,
		t.receiptLink,
		t.reference,
		t.refundedAmount,
		t.responseCode,
		t.responseDescription,
		t.scheme,
		t.status,
		t.surchargeAmount,
		t.taxAmounts((ta) => [ta.amount]),
		t.timestamp,
		t.tipAmount,
		t.type,
	] as const;
